import { PvCheckbox } from 'components/form/PvCheckbox';
import { updateLessons } from 'ducks/theoryLessons';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex, Text } from 'rebass';
import { bindActionCreators, compose } from 'redux';
import * as sort from 'sortabular';
import { PvCaret, PvCheck } from 'styles/CustomComponents';
import { resolve } from 'table-resolver';
import { filter, fixOrder, wrap, toggleChildren } from 'treetabular';

class TheoryLessonsDataTable extends React.Component {
  constructor(props) {
    super(props);
    const getSortingColumns = () => this.state.sortingColumns || {};
    const updateLessons = (lessons) => this.props.updateLessons(lessons);

    const toggleSelection = (lesson) => {
      const lessons = this.props.rows;
      const i = lessons.map((l) => l.entityId).indexOf(lesson.entityId);
      const updatedLessons = [
        ...lessons.slice(0, i),
        Object.assign(lessons[i], {selected: !lessons[i].selected}),
        ...lessons.slice(i + 1),
      ];
      updateLessons(updatedLessons);
    };

    const toggleShowChildren = (rowIndex) => {
      const lessons = this.props.rows;
      const updatedLessons = [
        ...lessons.slice(0, rowIndex),
        Object.assign(lessons[rowIndex], {showingChildren: !lessons[rowIndex].showingChildren}),
        ...lessons.slice(rowIndex + 1),
      ];

      updateLessons(updatedLessons);
    };

    const sortable = sort.sort({
      getSortingColumns,
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumn({
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      },
      strategy: sort.strategies.byProperty
    });

    const proColumns = this.props.showProColumns ?
      [
        {
          property: 'requiredForIndependentTraining',
          header: {
            label: <Translate value='datatable.independent_training' />,
          },
          props: {
            style: {
              textAlign: 'center'
            }
          },
          cell: {
            formatters: [
              isTrue => isTrue && <Text textAlign='center'><PvCheck /></Text>
            ]
          }
        },
        {
          property: 'requiredForPersonTransport',
          header: {
            label: <Translate value='datatable.person_transport' />,
          },
          props: {
            style: {
              textAlign: 'center'
            }
          },
          cell: {
            formatters: [
              isTrue => isTrue && <Text textAlign='center'><PvCheck /></Text>
            ]
          }
        },
      ] : [];

    const columns = [
      {
        property: 'description',
        header: {
          label: <Flex alignItems='center' justifyContent='space-between'><Translate
            value='search.lesson' /><PvCaret /></Flex>,
          transforms: [sortable],
          formatters: [
            sort.header({
              sortable,
              getSortingColumns: getSortingColumns,
              strategy: sort.strategies.byProperty
            }),
          ],
          props: {
            style: {
              minWidth: '15em'
            }
          }
        },
        cell: {
          formatters: [
            (value, {rowData}) => {
              if (rowData._isParent) {
                return <Text>{value}</Text>;
              } else {
                return (
                  <Flex alignItems='center'>
                    <PvCheckbox type="checkbox" checked={rowData.selected} onChange={() => {
                      toggleSelection(rowData);
                      this.forceUpdate();
                    }} />
                    <Text ml='1em'>{value}</Text>
                  </Flex>
                );
              }
            },
            toggleChildren({
              idField: 'lessonId',
              getRows: () => this.props.rows,
              getShowingChildren: ({rowData}) => rowData.showingChildren,
              toggleShowingChildren: rowIndex => toggleShowChildren(rowIndex),
            }),
          ],
          props: {
            style: {
              minWidth: '16em'
            }
          }
        },
      },
      ...proColumns,
    ];

    const propsReorder = (newProps) => {
      const props = newProps || this.props;
      this.setState({
        rows: compose(
          fixOrder({
            idField: 'lessonId'
          }),
          resolve({columns}),
        )(props.rows)
      });
    };

    this.propsReorder = propsReorder.bind(this);

    this.state = {
      // Default sorting
      sortingColumns: {},
      columns,
      rows: resolve({columns})(this.props.rows || [])
    };
  }

  componentWillReceiveProps(props) {
    this.propsReorder(props);
  }

  componentWillMount() {
    this.propsReorder();
  }

  render() {

    const {
      stylingRenderers,
      rowKey
    } = this.props;

    const {sortingColumns, columns, rows} = this.state;
    const finalRows = compose(
      filter({
        idField: 'lessonId',
        fieldName: 'showingChildren'
      }),
      wrap({
        idField: 'lessonId',
        operations: [
          sort.sorter({
            columns,
            sortingColumns,
            sort: orderBy,
            strategy: sort.strategies.byProperty
          })
        ]
      }),
    )(rows);

    //Forces table to update. Source: https://reactabular.js.org/#/table/overriding-should-component-update.
    //Needed in order to get disabled status to change when props change.
    //Causes "Warning: Stateless function components cannot be given refs. Attempts to access this ref will fail." in which no solution was found
    const BodyWrapper = props => <tbody {...props} />;
    BodyWrapper.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
      return true;
    };
    const renderers = Object.assign(stylingRenderers, {body: Object.assign(stylingRenderers.body, {wrapper: BodyWrapper})});

    return (
      <Table.Provider
        renderers={renderers}
        columns={columns}>
        <Table.Header />
        <Table.Body rows={finalRows} rowKey={rowKey || 'entityId'} />
      </Table.Provider>
    );
  }
}

TheoryLessonsDataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  stylingRenderers: PropTypes.object,
  rowKey: PropTypes.string,
  showProColumns: PropTypes.bool,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  updateLessons: (lessons) => updateLessons(lessons),
}, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(TheoryLessonsDataTable);


// WEBPACK FOOTER //
// ./src/components/datatable/TheoryLessonsDataTable.jsx